var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 301,
    viewBox: "0 0 410 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M363.521 66.1251C363.521 66.1251 358.226 40.2174 340.556 41.9826C332.525 42.7838 327.148 46.8148 322.491 53.068C316.513 61.0926 314.354 56.4293 305.816 59.0583C298.161 61.4181 299.337 67.8966 294.624 69.0733C289.911 70.2501 286.38 64.9484 279.902 66.1251C273.423 67.3019 269.887 73.7804 269.887 73.7804H387.67C387.357 71.5836 386.411 69.5256 384.947 67.8581C383.483 66.1906 381.564 64.9859 379.427 64.3913C371.765 62.0064 368.235 67.8966 363.521 66.1251Z",
    stroke: "#699595",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.2694 64.41C85.2694 64.41 81.9206 48.0542 70.7726 49.1684C65.6962 49.6816 62.3099 52.2167 59.3679 56.1664C55.6123 61.2303 54.2477 58.2883 48.8458 59.922C44.0136 61.4118 44.7584 65.4992 41.779 66.2441C38.7995 66.9889 36.5774 63.6401 32.49 64.3662C28.4026 65.0923 26.168 69.1985 26.168 69.1985H100.505C100.312 67.8081 99.7169 66.5044 98.7927 65.4479C97.8685 64.3914 96.6556 63.6281 95.3032 63.2521C90.471 61.8061 88.2426 65.5242 85.2694 64.41Z",
    stroke: "#699595",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M365.595 166.002C365.595 166.002 362.653 151.637 352.857 152.62C348.407 153.064 345.427 155.299 342.842 158.766C339.525 163.211 338.342 160.644 333.597 162.084C329.353 163.392 330.004 166.985 327.394 167.636C324.784 168.287 322.825 165.351 319.257 166.002C315.689 166.653 313.711 170.246 313.711 170.246H378.997C378.827 169.025 378.304 167.881 377.492 166.953C376.68 166.026 375.615 165.356 374.427 165.026C370.152 163.718 368.193 166.985 365.595 166.002Z",
    stroke: "#699595",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.833 85.0536L348.702 94.5867L258.61 149.407L242.404 179.915L138.961 218.047L31.2617 289.104H94.5883L162.321 238.065L265.283 200.408L283.397 167.039L370.153 107.456L388.268 121.283L408.767 71.2265V65.4804L335.833 85.0536Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335.832 79.3012L348.701 88.8343L258.609 143.654L242.404 174.163L138.961 212.295L24.8828 289.104H88.178L162.321 232.319L265.282 194.662L283.397 161.293L370.152 101.71L388.267 115.531L408.767 65.4804L335.832 79.3012Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.883 188.603L260.992 190.368",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M246.223 177.975L256.269 186.406",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.422 145.088L269.094 149.851",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.983 230.41L139.836 216.958",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.832 85.0536V79.3012L348.701 88.8343L344.464 91.4632L335.832 85.0536Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M388.267 121.283V115.531L370.152 101.71V107.456L388.267 121.283Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.037 113.039L166.281 120.1C166.281 120.1 167.189 121.296 167.533 121.102C167.877 120.907 169.724 117.709 169.724 117.709L168.247 123.173C168.247 123.173 168.841 124.119 169.211 123.705C169.58 123.292 170.926 119.38 171.264 119.324C171.602 119.268 172.397 117.853 172.397 117.853L171.032 122.291C171.032 122.291 170.519 124.375 171.426 124.231C172.334 124.087 172.397 122.072 172.397 122.072L174.325 119.111L173.605 122.291C173.605 122.291 174.857 123.18 175.051 122.416C175.245 121.652 175.927 118.66 175.927 118.66C175.927 118.66 179.057 114.905 179.42 114.485C179.783 114.066 181.629 109.534 181.629 109.534L178.838 105.603L170.037 113.039Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.32 106.48L170.884 108.414C170.884 108.414 168.624 113.922 167.979 114.873C167.335 115.825 168.111 116.006 169.269 115.543C170.427 115.08 172.436 112.464 172.436 112.464C172.436 112.464 175.973 112.989 177.143 111.074",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.32 106.48L170.884 108.414C170.884 108.414 168.624 113.922 167.979 114.873C167.335 115.825 168.111 116.006 169.269 115.543C170.427 115.08 172.436 112.464 172.436 112.464C172.436 112.464 175.973 112.989 177.143 111.074",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.605 115.631L174.798 117.471",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.961 45.4252L239.428 84.8971L240.793 89.1723C240.793 89.1723 225.902 95.3941 222.81 95.8886C221.366 96.0854 219.939 96.3887 218.541 96.7962L202.961 57.7249L208.244 49.3123L220.9 44.0481L223.961 45.4252Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.051 66.1438L231.33 89.0596",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M219.985 176.429C219.767 178.485 219.444 180.528 219.014 182.55C218.539 184.284 217.024 189.029 217.249 190.268C217.475 191.507 218.683 196.815 219.421 197.21C220.16 197.604 221.262 197.698 221.862 197.21C222.463 196.722 225.518 190.763 225.806 188.684C226.094 186.606 225.9 179.827 225.944 179.295C225.987 178.763 219.985 176.429 219.985 176.429Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M285.234 137.695C285.234 137.695 290.242 140.011 290.905 140.068C291.569 140.124 297.277 140.694 297.277 140.694C297.277 140.694 302.01 139.767 302.748 140.161C303.487 140.556 303.23 142.308 303.23 142.308C303.23 142.308 293.71 147.366 292.357 147.692C291.005 148.017 289.384 147.441 288.477 147.692L287.569 147.948L288.333 149.344L282.643 152.405C282.643 152.405 280.139 149.526 280.039 147.861C279.939 146.196 279.876 143.304 279.876 143.304L279.062 139.905L285.234 137.695Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.652 44.4988C222.652 44.4988 233.293 71.6584 235.309 75.8397C237.324 80.021 239.115 85.0661 240.667 86.3743C242.219 87.6825 236.667 72.5285 236.141 69.549C235.616 66.5695 235.697 60.9986 235.697 60.9986L282.467 44.9557L280.715 39.1282L241.656 43.804C241.656 43.804 233.706 42.9277 232.041 42.984C230.376 43.0403 222.652 44.4988 222.652 44.4988Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.201 43.8541C224.28 44.1921 222.652 44.48 222.652 44.48C222.652 44.48 230.101 63.4398 233.713 72.1154C233.412 67.1223 232.677 62.1649 231.516 57.2993C230.223 52.6429 228.441 48.1362 226.201 43.8541Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M237.129 48.8929L235.695 60.9986L239.426 49.4813",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M280.715 39.1282L283.588 38.69L284.721 43.779L282.467 44.9495L280.715 39.1282Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M293.893 37.2254C293.893 37.2254 296.303 37.626 296.253 38.2081C296.203 38.7902 295.345 41.9638 295.345 41.9638C294.19 42.2518 292.982 42.2518 291.827 41.9638C290.306 41.4442 289.812 40.3238 290.194 39.2785C290.575 38.2331 293.893 37.2254 293.893 37.2254Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M292.137 38.3458L294.127 39.1032L293.914 41.5318",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M291.398 38.8716L292.581 39.9482C292.652 40.2382 292.652 40.5408 292.581 40.8308",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M283.598 38.6901L291.109 36.9813C291.109 36.9813 298.314 33.983 298.57 34.3961C298.717 34.5782 298.788 34.8102 298.769 35.0434C298.749 35.2767 298.64 35.4934 298.464 35.648C298.038 36.0048 292.786 37.9014 292.167 38.3396C291.547 38.7777 291.159 39.8168 291.603 40.3488C291.866 40.7172 292.212 41.0177 292.614 41.2256C293.016 41.4335 293.461 41.5428 293.913 41.5444C295.002 41.438 297.669 41.0812 297.738 41.4818C297.807 41.8824 298.051 42.3894 297.112 42.7337C296.173 43.0779 294.746 42.9214 294.051 43.0592C293.356 43.1969 290.546 44.0294 289.475 43.9355C288.496 43.7856 287.534 43.5403 286.602 43.2031L284.693 43.8291L283.598 38.6901Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M238.527 84.9785C238.527 84.9785 246.351 100.189 246.965 100.201C247.578 100.214 254.664 94.8746 254.852 94.6305C255.04 94.3864 245.413 88.8843 242.696 86.0551C239.979 83.2258 237.582 80.0899 237.582 80.0899L238.527 84.9785Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M240.788 89.1722L244.544 95.7196C244.544 95.7196 264.18 93.4599 270.834 93.0155C277.487 92.5711 279.835 93.2784 279.835 93.2784L286.445 137.676L275.885 142.359L266.014 109.146C266.014 109.146 244.031 115.136 240.82 115.499C239.207 115.643 237.611 115.93 236.05 116.357C236.05 116.357 229.991 157.387 229.528 162.808C229.064 168.229 229.102 178.144 229.102 178.144L226.06 181.061C226.06 181.061 219.494 177.574 219.175 177.036C218.855 176.497 215.525 126.159 215.525 126.159L214.273 106.492L218.53 96.8213L240.788 89.1722Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M220.966 98.1357L241.716 91L240.79 89.1722L220.672 96.0075L220.966 98.1357Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M229.691 92.9091L230.662 95.2313L235.312 93.5851L234.436 91.3568L229.691 92.9091Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M225.29 135.893L225.246 133.37",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M226.064 181.036L225.332 138.547",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M236.055 116.332C236.055 116.332 237.275 107.894 239.779 102.887",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M241.03 98.962C241.03 98.962 237.393 104.908 236.836 106.204",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M272.68 107.018L274.489 106.448",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M266.016 109.121L270.81 107.606",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M217.875 59.7655L223.189 63.1268L224.861 55.3214L218.864 53.4686L217.875 59.7655Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M220.266 56.5669L215.734 66.5194L209.719 50.4452L222.657 44.4988L229.78 57.9816L220.266 56.5669Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M180.196 103.907L177.742 106.473L181.648 110.861L182.912 108.877L180.196 103.907Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.243 49.3123L193.458 60.9486L191.968 91.3819L179.449 104.527L183.117 110.098L201.27 95.7572L203.736 78.4249L207.172 88.3147L203.197 112.489C205.935 113.57 208.736 114.483 211.585 115.224C215.748 116.251 221.068 115.587 221.068 115.587L221.982 86.5621L210.327 48.8491L208.243 49.3123Z",
    fill: "#92E3A9",
    fillOpacity: 0.01,
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M208.832 92.9404L219.485 93.967V98.0669L208.625 96.4269",
    fill: "#699595"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M208.832 92.9404L219.485 93.967V98.0669L208.625 96.4269",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M210.304 48.8178L208.245 49.3123L205.547 51.4342C206.79 56.095 208.401 60.6495 210.367 65.0547C212.633 70.0623 216.92 75.8585 219.756 79.4514L210.304 48.8178Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M223.185 63.1268L212.807 71.89L193.546 69.3424L184.426 76.5095L182.461 81.154L190.304 82.4059L197.703 74.4188C197.703 74.4188 212.581 77.1542 213.389 76.8851C214.196 76.6159 222.152 65.7746 222.152 65.7746L223.185 63.1268Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M201.334 29.3322C201.334 29.3322 198.662 30.1021 197.429 28.506C196.195 26.9098 195.382 24.8442 196.471 25.1885C197.39 25.5384 198.269 25.9854 199.094 26.5217C199.094 26.5217 198.674 22.7661 199.557 22.5783C200.439 22.3905 200.809 24.0555 200.809 24.0555C200.809 24.0555 204.652 21.2764 208.946 20.7693C213.24 20.2623 219.587 22.6785 220.513 23.6236C221.44 24.5688 220.82 33.1004 220.638 33.7076C220.457 34.3147 220.094 35.7732 219.43 36.2113C218.767 36.6495 217.227 37.2629 216.42 36.5744C215.612 35.8858 215.694 34.8968 214.223 34.6465C212.752 34.3961 209.146 34.3335 208.908 32.8187C208.67 31.3039 210.26 28.5874 208.771 28.5811C207.281 28.5748 203.563 29.8768 202.568 29.9143C201.572 29.9519 201.334 29.3322 201.334 29.3322Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M201.328 29.3322V36.9187L202.843 38.9154L202.217 46.0762L205.347 45.8446C205.347 45.8446 207.431 51.9913 208.038 52.1666C208.645 52.3419 211.274 50.7019 211.274 50.7019C211.274 50.7019 219.818 56.905 220.219 56.567C220.62 56.229 222.278 45.5567 222.56 45.2061C222.842 44.8556 221.308 39.2597 221.308 39.2597C221.308 39.2597 222.523 36.7559 222.185 34.8781C221.847 33.0003 221.246 32.8062 221.246 32.8062C221.246 32.8062 219.937 32.0739 219.505 32.8062C219.074 33.5386 217.759 35.7669 217.759 35.7669L215.85 33.3633C215.85 33.3633 210.423 32.9001 210.486 32.1552C210.548 31.4104 211.738 27.6672 211.4 27.2604C211.062 26.8535 204.627 27.1477 201.328 29.3322Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M208.692 38.327C208.942 38.953 208.892 39.5789 208.579 39.6916C208.266 39.8042 207.809 39.4099 207.553 38.7839C207.296 38.158 207.352 37.5321 207.665 37.4257C207.978 37.3192 208.435 37.7011 208.692 38.327Z",
    fill: "#699595"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M204.211 37.6072C204.211 37.6072 206.026 41.4442 207.128 41.7447C208.229 42.0451 211.353 41.3879 211.754 40.2987C212.154 39.2096 211.052 35.335 211.052 35.335L204.211 37.6072Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M211.055 35.335L219.567 32.7624",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M204.21 37.6072L198.809 39.8042C198.809 39.8042 200.029 42.2642 202.101 41.9262",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M209.109 45.0809C209.109 45.0809 212.101 44.7241 212.746 42.0201",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M211.316 50.7019C211.316 50.7019 215.829 47.6035 216.38 47.1403C216.931 46.6771 217.488 44.9808 217.488 44.9808C217.488 44.9808 216.862 50.1448 216.437 51.2402C216.011 52.3356 215.529 53.5124 215.529 53.5124L211.316 50.7019Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M221.371 39.2597C221.371 39.2597 220.676 41.1688 219.543 41.2752",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M205.891 35.9109C206.26 35.353 206.795 34.9247 207.42 34.6856C208.045 34.4466 208.73 34.4088 209.377 34.5776",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M153.262 125.677L154.645 122.041L157.524 119.318C157.524 119.318 158.526 117.496 159.133 117.866C159.74 118.235 159.383 118.629 159.133 119.349C158.676 120.117 158.116 120.818 157.468 121.433C157.468 121.433 163.102 117.678 163.414 117.596C163.727 117.515 164.666 118.122 164.166 118.723C163.665 119.324 159.872 121.853 159.872 121.853L166.043 119.092C166.043 119.092 166.538 120.726 165.868 121.089C165.198 121.452 161.718 123.812 161.718 123.812C161.718 123.812 164.429 123.086 165.198 122.729C165.968 122.372 166.294 123.568 165.73 123.943C165.167 124.319 161.699 126.447 161.699 126.447C161.699 126.447 165.054 125.671 164.91 126.084C164.767 126.497 164.848 126.823 163.878 127.054C162.907 127.286 159.039 129.076 159.039 129.076L153.712 130.635L153.262 125.677Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M151.316 126.954L153.269 125.677L155.592 130.741L152.812 132.469L151.316 126.954Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2852 173.362C78.2852 173.362 78.8297 180.009 78.7734 180.673C78.7171 181.336 81.5901 184.384 82.3287 184.891C83.0674 185.398 85.7088 184.622 85.7088 184.622C85.7088 184.622 88.6132 180.735 88.3753 179.615C88.2569 178.965 87.9107 178.379 87.3989 177.962L83.8122 174.601L82.6667 173.18L78.2852 173.362Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3429 180.954L81.8594 182.613C81.8594 182.613 82.5479 183.683 83.2364 183.514L83.9187 183.352",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6651 173.18C82.6651 173.18 86.4207 176.516 87.1656 176.804C87.4784 176.946 87.74 177.181 87.9147 177.476C88.0894 177.772 88.1688 178.114 88.142 178.457C86.9774 179.673 85.7219 180.799 84.3864 181.824C83.6728 182.325 83.0344 181.931 83.3411 180.954C83.6478 179.978 84.3363 178.45 84.3363 178.45C84.3363 178.45 82.8716 178.544 82.5273 177.399",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6651 173.18C82.6651 173.18 86.4207 176.516 87.1656 176.804C87.4784 176.946 87.74 177.181 87.9147 177.476C88.0894 177.772 88.1688 178.114 88.142 178.457C86.9774 179.673 85.7219 180.799 84.3864 181.824C83.6728 182.325 83.0344 181.931 83.3411 180.954C83.6478 179.978 84.3363 178.45 84.3363 178.45C84.3363 178.45 82.8716 178.544 82.5273 177.399",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9922 170.32L78.2926 173.362C78.2926 173.362 79.8825 174.394 81.0092 174.269C81.9116 174.084 82.774 173.741 83.5568 173.255L84.4707 171.158L77.9922 170.32Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M141.003 216.051C141.003 216.051 138.9 223.612 138.875 225.183C138.945 226.849 139.104 228.51 139.351 230.159C139.351 230.159 139.977 230.785 141.56 230.573C142.691 230.487 143.79 230.161 144.784 229.615C145.147 229.308 145.103 227.174 145.103 227.174C145.103 227.174 146.655 227.418 147.757 227.624C148.859 227.831 152.47 226.373 153.873 225.678C155.275 224.983 157.897 223.218 158.254 221.791C158.611 220.364 157.628 219.719 157.196 219.681C156.764 219.644 151.256 219.619 150.042 219.4C148.827 219.18 146.756 217.102 146.674 216.758C146.593 216.414 141.003 216.051 141.003 216.051Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M111.38 246.171L111.643 249.67C111.643 249.67 114.146 252.919 114.922 253.319C115.699 253.72 117.351 253.751 117.489 254.772C117.627 255.792 117.921 256.268 117.107 256.649C116.293 257.031 113.045 258.208 111.805 258.214C110.566 258.22 108.3 257.238 108.3 257.238L107.962 258.558C107.236 258.835 106.46 258.959 105.684 258.922C104.781 258.908 103.886 258.756 103.03 258.471C103.03 258.471 102.491 255.623 102.735 254.089C102.98 252.556 103.987 248.456 103.987 248.456L104.864 244.825L111.38 246.171Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1875 174.732L101.036 180.679L108.954 209.428L104.184 245.476C104.184 245.476 105.968 246.86 107.414 246.985C108.86 247.11 112.453 246.853 112.453 246.853L120.859 208.771L122.267 180.604L144.226 181.48L139.844 216.965C139.844 216.965 142.579 217.647 143.6 217.728C145.153 217.662 146.7 217.497 148.232 217.234C148.232 217.234 158.535 172.974 158.841 171.991C158.98 171.695 159.047 171.371 159.036 171.044C159.025 170.718 158.937 170.399 158.779 170.113C158.497 169.525 133.297 163.453 133.297 163.453C133.297 163.453 103.74 175.208 98.1875 174.732Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M122.289 180.597L109.695 179.765L121.732 188.622L122.289 180.597Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2252 116.363C98.2252 116.363 90.7139 120.845 90.2194 122.379C89.7249 123.912 79.3968 149.044 79.3092 150.089C79.2216 151.134 77.3438 171.465 77.3438 171.465C78.3772 171.87 79.4586 172.139 80.5611 172.266C82.1259 172.398 84.467 171.158 84.467 171.158L89.0489 149.876L97.2675 139.817L99.6648 148.693L93.9312 175.778C93.9312 175.778 103.546 178.569 113.642 175.778C123.739 172.986 135.206 163.303 135.206 163.303C135.206 163.303 129.316 152.286 127.695 150.045C126.073 147.804 124.671 145.451 124.671 145.451L124.815 140.731C124.815 140.731 133.478 150.014 134.423 149.701C135.369 149.388 153.903 132.45 153.903 132.45L151.349 126.973L134.48 135.254C134.48 135.254 126.011 116 124.233 115.324C122.455 114.648 118.55 114.179 118.55 114.179C118.55 114.179 106.412 111.287 98.2252 116.363Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M110.518 83.2635C111.269 84.1252 111.912 85.0753 112.433 86.0927C113.404 87.9205 113.648 89.8922 115.125 90.6371C116.602 91.3819 118.662 91.263 118.605 91.9578C118.549 92.6526 117.385 94.2174 117.385 94.2174C117.385 94.2174 119.093 100.621 118.693 101.729C118.292 102.837 113.253 105.265 113.253 105.265V111.018L105.811 111.612C104.563 108.452 103.538 105.208 102.744 101.904C101.868 97.7227 105.974 95.3066 105.874 90.3742C105.773 85.4417 106.631 82.7377 107.676 82.5186C108.722 82.2995 110.518 83.2635 110.518 83.2635Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M113.715 90.7748C113.965 91.4007 113.934 92.0267 113.646 92.1206C113.358 92.2145 112.92 91.8201 112.669 91.1942C112.419 90.5682 112.45 89.9423 112.738 89.8421C113.026 89.742 113.464 90.1426 113.715 90.7748Z",
    fill: "#699595"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M111.647 89.3101C111.647 89.3101 111.546 88.0582 112.754 88.3775",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M117.976 96.8339C117.729 97.0991 117.407 97.2833 117.053 97.3626C116.699 97.4419 116.329 97.4125 115.992 97.2783",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M109.498 85.6358C109.498 85.6358 111.138 89.2663 110.306 91.7638C109.755 93.3605 109.004 94.8811 108.071 96.2893C108.071 96.2893 106.425 98.718 106.7 100.283C106.976 101.848 108.628 107.732 109.116 108.082L109.598 108.433L110.631 109.547C110.631 109.547 105.211 112.883 99.3017 113.609C93.3928 114.335 89.5057 112.871 88.7295 112.395C88.2225 112.077 87.7373 111.726 87.2773 111.343C87.2773 111.343 90.2881 106.16 90.3445 100.702C90.4008 95.244 88.7358 91.939 90.3445 87.1568C91.9531 82.3746 104.203 79.9272 104.203 79.9272C104.203 79.9272 104.766 78.1245 107.113 78.3248C109.461 78.5251 111.808 83.4513 111.808 83.4513L109.498 85.6358Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M108.84 98.1046C108.84 98.1046 107.012 95.4819 106.01 97.5537C105.009 99.6256 108.214 102.974 109.841 101.985",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M108.84 98.1046C108.84 98.1046 107.012 95.4819 106.01 97.5537C105.009 99.6256 108.214 102.974 109.841 101.985",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M106.366 110.361C106.366 110.361 112.325 109.822 113.364 109.91C114.403 109.997 116.894 111.656 116.894 111.656L116.725 113.615C116.725 113.615 110.948 112.069 107.737 112.714C104.526 113.359 99.9375 114.78 99.9375 114.78L100.858 111.7C100.858 111.7 103.994 110.398 106.366 110.361Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2227 116.363L99.2993 113.609C99.2993 113.609 107.155 111.688 110.216 111.35C112.885 111.118 115.567 111.62 117.971 112.802C118.78 113.242 119.416 113.944 119.774 114.792C119.774 114.792 113.59 113.346 108.144 114.06C104.772 114.514 101.45 115.285 98.2227 116.363Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M124.788 140.712L116.914 132.932C116.914 132.932 115.149 130.547 116.144 126.56",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2648 139.799L92.6328 127.975",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M292.398 177.532V172.286H301.569V177.532C309.519 179.146 313.594 185.201 313.594 194.785V197.007H302.996V194.082C302.996 189.034 300.959 187.119 297.39 187.119C293.822 187.119 291.784 189.034 291.784 194.082C291.784 208.612 313.714 209.319 313.714 229.501C313.714 239.085 309.535 245.242 301.585 246.869V252H292.414V246.869C284.36 245.254 280.285 239.097 280.285 229.501V224.658H290.867V230.207C290.867 235.252 293.112 237.068 296.68 237.068C300.249 237.068 302.49 235.252 302.49 230.207C302.49 215.674 280.56 214.967 280.56 194.785C280.572 185.3 284.547 179.245 292.398 177.532Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M154.602 255.155V252H160.012V255.155C164.701 256.127 167.109 259.771 167.109 265.54V266.878H160.83V265.132C160.83 262.099 159.632 260.941 157.529 260.941C155.426 260.941 154.222 262.105 154.222 265.132C154.222 273.864 167.144 274.306 167.144 286.455C167.144 292.223 164.678 295.931 159.989 296.903V300H154.579V296.903C149.832 295.931 147.43 292.246 147.43 286.455V283.544H153.68V286.891C153.68 289.93 155 291.018 157.137 291.018C159.274 291.018 160.559 289.93 160.559 286.891C160.559 278.16 147.637 277.717 147.637 265.569C147.631 259.835 149.976 256.191 154.602 255.155Z",
    stroke: "#699595",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondImg);
export default __webpack_public_path__ + "static/media/SecondImg.fe1debc3232c7c8bb4c8426bfe1e3532.svg";
export { ForwardRef as ReactComponent };